import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { FaEdit, FaTrash, FaReply, FaDownload, FaPaperclip } from 'react-icons/fa';
import { formatarData } from './InformacoesTab';

const ModalVisualizarPergunta = ({
    show,
    onHide,
    pergunta,
    codigoUsuarioLogado,
    isGerente,
    onEditar,
    onExcluir,
    onResponder,
    anexos = [],
    loadingAnexos = false,
    onDownloadAnexo
}) => {
    if (!pergunta) return null;

    const handleDownload = async (anexo) => {
        try {
            await onDownloadAnexo(anexo.codigo, anexo.nome_arquivo);
        } catch (error) {
            console.error('Erro ao baixar anexo:', error);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Detalhes da Pergunta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <small className="text-muted">
                        {pergunta.nome_usuario_criacao} - {formatarData(pergunta.data)}
                    </small>
                </div>
                <h5>{pergunta.titulo}</h5>
                <div className="mb-3">
                    {pergunta.assunto && (
                        <span className="mr-3"><strong>Assunto:</strong> {pergunta.assunto}</span>
                    )}
                    {pergunta.empreendimento && (
                        <span><strong>Empreendimento:</strong> {pergunta.empreendimento}</span>
                    )}
                </div>
                {pergunta.descricao && (
                    <p style={{ whiteSpace: 'pre-wrap' }}>{pergunta.descricao}</p>
                )}

                <div className="mt-3">
                    <strong><FaPaperclip className="mr-1" />Anexos:</strong>
                    {loadingAnexos ? (
                        <div className="mt-2">
                            <Spinner animation="border" size="sm" /> Carregando...
                        </div>
                    ) : anexos.length > 0 ? (
                        <ul className="list-unstyled mt-2">
                            {anexos.map((anexo) => (
                                <li key={anexo.codigo} className="mb-2">
                                    <Button
                                        variant="link"
                                        className="p-0 text-primary"
                                        onClick={() => handleDownload(anexo)}
                                    >
                                        <FaDownload className="mr-1" />
                                        {anexo.nome_arquivo}
                                    </Button>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-muted mt-2 mb-0">Nenhum anexo</p>
                    )}
                </div>

                {pergunta.status == 'R' && (
                    <div className="mt-4 pt-3 border-top">
                        <h6 className="font-weight-bold">Resposta</h6>
                        {pergunta.link_resposta && (
                            <p className="mb-2">
                                <strong>Link:</strong>{' '}
                                <a href={pergunta.link_resposta} target="_blank" rel="noopener noreferrer">
                                    {pergunta.link_resposta}
                                </a>
                            </p>
                        )}
                        {pergunta.resposta && (
                            <p style={{ whiteSpace: 'pre-wrap' }}>{pergunta.resposta}</p>
                        )}
                        <small className="text-muted">
                            Respondido por {pergunta.nome_usuario_resposta} em {formatarData(pergunta.data_resposta)}
                        </small>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                {codigoUsuarioLogado && pergunta.codigo_usuario_criacao == codigoUsuarioLogado && (
                    <>
                        <Button
                            variant="outline-primary"
                            onClick={() => {
                                onHide();
                                onEditar(pergunta);
                            }}
                        >
                            <FaEdit className="mr-1" /> Editar
                        </Button>
                        <Button
                            variant="outline-danger"
                            onClick={() => {
                                onHide();
                                onExcluir(pergunta);
                            }}
                        >
                            <FaTrash className="mr-1" /> Excluir
                        </Button>
                    </>
                )}
                {pergunta.status == 'P' && isGerente && (
                    <Button variant="primary" onClick={onResponder}>
                        <FaReply className="mr-1" /> Responder
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ModalVisualizarPergunta;
